/*
 * @Author: 陈祝文 15821704398@163.com
 * @Date: 2024-02-22 10:30:12
 * @LastEditors: 陈祝文 15821704398@163.com
 * @LastEditTime: 2024-02-27 14:53:06
 * @FilePath: \weben-les-web\src\utils\loadding.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {ElLoading} from 'element-plus'
import { ILoadingInstance } from "element-plus/lib/el-loading/src/loading.type";
class LoaddingApi {
    loadding?: ILoadingInstance | null
    ele: any
    text:any
    background: any
    state: any = 'close'
    //构造函数
    constructor(ele: any = document.body,text: any = '加载中...',background: any = 'rgba(255,255,255,.1)' ) {
        this.ele = ele
        this.text = text
        this.background = background
    }
    /**
     * 创建loadding对象，如果存在直接返回
     * @returns 
     */
    create() {
        if(this.state == 'open') return
        this.loadding = ElLoading.service({
            target: this.ele,
            text: this.text,
            background: this.background
        })
        this.state = 'open'
    }
    //关闭loading
    close() {
        if(this.state == 'close') return
        setTimeout(() => {
            this.loadding?.close()
            this.state = 'close'
        }, 500);
        
    }

}

export default LoaddingApi